var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { ElementRef } from '@angular/core';
import { BsDaterangepickerDirective } from 'ngx-bootstrap';
var CeDateRangePickerDirective = /** @class */ (function () {
    function CeDateRangePickerDirective(bsDaterangepicker, el) {
        this.bsDaterangepicker = bsDaterangepicker;
        this.el = el;
        this.el.nativeElement.placeholder = "mm/dd/yyyy - mm/dd/yyyy";
        this.bsDaterangepicker.placement = "right";
        this.bsDaterangepicker.bsConfig = __assign({}, this.bsDaterangepicker.bsConfig, { containerClass: "theme-dark-blue", showWeekNumbers: false, displayMonths: 1 });
    }
    return CeDateRangePickerDirective;
}());
export { CeDateRangePickerDirective };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/shared/directives/ce-date-range-picker.directive.ts.pre-build-optimizer.js